import React from 'react'

import { findIndex } from 'lodash'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import * as PureGenericEvent from './PureGenericEvent'

export const eventHOC = (Comp) => {
  class GenericEvent extends React.Component {
    getCalendarIndex() {
      return findIndex(this.props.calendars, ['id', this.props.event.ExternalCalendarId])
    }
    render() {
      return (
        <Comp
          {...this.props}
          linkedCalendarIndex={this.getCalendarIndex()}
          linkedCalendarName={this.props.calendars[this.getCalendarIndex()]?.label ?? ''}
        />
      )
    }
  }
  GenericEvent.propTypes = {
    calendars: PropTypes.array.isRequired,
    event: PropTypes.object.isRequired,
  }
  return GenericEvent
}
const connectFn = (state) => ({
  calendars: state.linkedCalendars,
})
export const WeekView = connect(connectFn)(eventHOC(PureGenericEvent.WeekView))

export const MonthView = connect(connectFn)(eventHOC(PureGenericEvent.MonthView))
